import React from 'react';

import { colors } from 'styles/cp';

interface Props {
  content: string;
}

const FormSectionHeader: React.FC<Props> = ({ content }) => {
  return (
    <React.Fragment>
      <div className="content">{content}</div>

      {/*language=CSS*/}
      <style jsx>{`
        .content {
          font-family: AvenirNextforINTUIT-Demi;
          text-transform: uppercase;
          font-size: 12px;
          color: ${colors.gray02};
        }
      `}</style>
    </React.Fragment>
  );
};

export default FormSectionHeader;
